import { z } from 'zod';
import { IAsset } from './IAsset';
import { IAssetCategoryId } from './IAssetCategory';
import { IAssetTypeId } from './IAssetType';
import { GenericAssetSchema } from './IGenericAsset';

export const LoanAssetVersion = {
  Initial: 1,
} as const;

export type LoanAssetVersion =
  (typeof LoanAssetVersion)[keyof typeof LoanAssetVersion];

export function getEmptyLoanAsset(idAsset: number): ILoanAsset {
  return {
    idAsset,
    idAssetType: IAssetTypeId.Loan,
    idAssetCategory: IAssetCategoryId.Liabilities,
    Version: LoanAssetVersion.Initial,
    data: {
      amount: 0,
      notes: '',
    },
  };
}

export function isLoanAsset(asset: IAsset): asset is ILoanAsset {
  return asset.idAssetType === IAssetTypeId.Loan;
}

export const LoanAssetDataSchema = z.object({
  amount: z.number(),
  notes: z.string().optional(),
});

export const LoanAssetSchema = GenericAssetSchema(
  z.literal(IAssetTypeId.Loan),
  z.literal(IAssetCategoryId.Liabilities),
  z.literal(LoanAssetVersion.Initial).optional(),
  LoanAssetDataSchema
);

export type ILoanAsset = z.infer<typeof LoanAssetSchema>;
